module.exports = __webpack_public_path__ + "static/media/expandSidebar.4bd5bdf9.svg";